import { Form, Select } from 'antd';
import { selectHerePlaceholder } from '../../constants/translations';

export const SupSpecific = ({
  selectionOptions,
}: { selectionOptions: string[] }) => {
  return (
    <Form.Item
      label="Sutrikimai"
      name={['registration', 'supSpecific']}
      style={{ display: selectionOptions?.length > 0 ? 'block' : 'none' }}
    >
      <Select placeholder={selectHerePlaceholder} showSearch={true}>
        {selectionOptions?.map((item, index) => (
          <Select.Option key={`selector_item_${index + 1}`} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
